import React, { useEffect, useState } from 'react';
import './ConnectionsRedirectModal.css';

interface ConnectionsRedirectModalProps {
    onClose: () => void;
}

const ConnectionsRedirectModal: React.FC<ConnectionsRedirectModalProps> = ({ onClose }) => {
    const [redirected, setRedirected] = useState(false);
    const [secondsRemaining, setSecondsRemaining] = useState(45);

    useEffect(() => {
        // First phase: show redirect message and then redirect
        const redirectTimer = setTimeout(() => {
            window.open('https://www.nytimes.com/games/connections', '_blank');
            setRedirected(true);
        }, 1500);

        // Cleanup redirect timer
        return () => clearTimeout(redirectTimer);
    }, []);

    // Second phase: countdown timer after redirect
    useEffect(() => {
        if (redirected) {
            const countdownInterval = setInterval(() => {
                setSecondsRemaining(prev => {
                    if (prev <= 1) {
                        clearInterval(countdownInterval);
                        onClose();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(countdownInterval);
        }
    }, [redirected, onClose]);

    return (
        <div className="connections-modal-overlay">
            <div className="connections-modal-content">
                {!redirected ? (
                    <h2>Redirecting to the Connections of the day...</h2>
                ) : (
                    <h2>You must complete the connections of the day to unlock this page again</h2>
                )}
            </div>
        </div>
    );
};

export default ConnectionsRedirectModal; 